import { Injectable } from '@nestjs/common'
import { IAplicacion } from '../../../interfaces'
import { CuentaModel } from '../models/aplicacion.model'

@Injectable()
export class WebhookAplicacionService {
  async obtenerAplicacion(identificador: string) {
    return await CuentaModel.findOne({
      attributes: ['apiKey', 'identificador', 'token', 'id', 'redirect'],
      where: {
        identificador,
      },
    })
  }
  async obtenerAplicacionApi(apiKey: string) {
    return await CuentaModel.findOne({
      where: {
        apiKey,
      },
    })
  }
  async agregarAplicacion(aplicacion: IAplicacion, transaction = null) {
    return await CuentaModel.create(aplicacion, { transaction })
  }
  async actualizarAccessToken(id: number, token: string) {
    return await CuentaModel.update({ token }, { where: { id } })
  }

  async actualizar(id: number, data) {
    return await CuentaModel.update({ nombre: data.nombre, identificador: data.identificador }, { where: { id } })
  }
}
